import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Collapsible() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="dark:bg-gray-900">
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon className="dark:bg-gray-800 dark:text-gray-300" />
          }
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="dark:bg-gray-800 dark:text-gray-300"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            AV Labor Crews
          </Typography>
          <Typography
            sx={{ color: "text.secondary" }}
            className="dark:bg-gray-800 dark:text-gray-300"
          >
            Join the team. We are hiring!
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="dark:bg-gray-900 dark:text-gray-300">
          <Typography>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum
            mollitia quasi dolore at aliquam harum modi. Cum cumque
            exercitationem consequuntur culpa dolorum debitis facilis unde quasi
            odit. Aspernatur, rerum temporibus? Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Vitae sunt, recusandae vel provident
            suscipit saepe nisi maiores laboriosam, quibusdam quasi nihil qui
            esse fugit atque dolorum dolor quisquam commodi cupiditate.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon className="dark:bg-gray-800 dark:text-gray-300" />
          }
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="dark:bg-gray-800 dark:text-gray-300"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            Cost Effective AV Rental
          </Typography>
          <Typography
            sx={{ color: "text.secondary" }}
            className="dark:bg-gray-800 dark:text-gray-300"
          >
            Create extravagant events without breaking the bank
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="dark:bg-gray-900 dark:text-gray-300">
          <Typography>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum
            mollitia quasi dolore at aliquam harum modi. Cum cumque
            exercitationem consequuntur culpa dolorum debitis facilis unde quasi
            odit. Aspernatur, rerum temporibus? Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Vitae sunt, recusandae vel provident
            suscipit saepe nisi maiores laboriosam, quibusdam quasi nihil qui
            esse fugit atque dolorum dolor quisquam commodi cupiditate.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon className="dark:bg-gray-800 dark:text-gray-300" />
          }
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="dark:bg-gray-800 dark:text-gray-300"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            Locally Owned
          </Typography>
          <Typography
            sx={{ color: "text.secondary" }}
            className="dark:bg-gray-800 dark:text-gray-300"
          >
            Support us and we will support you
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="dark:bg-gray-900 dark:text-gray-300">
          <Typography>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum
            mollitia quasi dolore at aliquam harum modi. Cum cumque
            exercitationem consequuntur culpa dolorum debitis facilis unde quasi
            odit. Aspernatur, rerum temporibus? Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Vitae sunt, recusandae vel provident
            suscipit saepe nisi maiores laboriosam, quibusdam quasi nihil qui
            esse fugit atque dolorum dolor quisquam commodi cupiditate.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon className="dark:bg-gray-800 dark:text-gray-300" />
          }
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="dark:bg-gray-800 dark:text-gray-300"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            Full Service Production
          </Typography>
          <Typography
            sx={{ color: "text.secondary" }}
            className="dark:bg-gray-800 dark:text-gray-300"
          >
            Save more by hiring one company
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="dark:bg-gray-900 dark:text-gray-300">
          <Typography>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum
            mollitia quasi dolore at aliquam harum modi. Cum cumque
            exercitationem consequuntur culpa dolorum debitis facilis unde quasi
            odit. Aspernatur, rerum temporibus? Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Vitae sunt, recusandae vel provident
            suscipit saepe nisi maiores laboriosam, quibusdam quasi nihil qui
            esse fugit atque dolorum dolor quisquam commodi cupiditate.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default Collapsible;
